module.exports = __webpack_public_path__ + "static/media/eduCATImg.d87d3204.svg";